import React from 'react'
import { HtmlEditorField } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { FormSection } from 'scenes/Dashboard/components-next/Sections'
import { FastField } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { FormControl, Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export type CorporateAdminNotesProps = ExtendableStyles & Testable

export function CorporateAdminNotes(styleProps: CorporateAdminNotesProps) {
  const { classes } = useFormStyles()
  return (
    <FormSection title="Notes" {...styleProps}>
      <FormControl className={classes.field}>
        <FastField name="adminNotes" component={HtmlEditorField} removeDefaultHtmlStyle />
      </FormControl>
    </FormSection>
  )
}

const useFormStyles = makeStyles()(({ spacing }: Theme) => ({
  formContainer: {
    display: 'flex',
    gap: spacing(5),
  },
  formSection: {
    paddingBottom: spacing(5),
  },
  field: {
    width: '100%',
    marginBottom: spacing(2),
  },
  booleanFields: {
    marginTop: spacing(),
    display: 'flex',
  },
  inlineField: {
    marginRight: spacing(3),
    flex: '0 0 auto',
  },
  label: {
    position: 'relative',
  },
  dangerZone: {
    background: '#FADBD8',
    padding: spacing(2),
    marginBottom: spacing(2),
  },
}))
